import * as React from 'react';
import { Row, Col, Input } from 'antd';
import { FormItem } from '../../../../Form';
import DiscountInput from 'src/components/Others/DiscountInput';
import { calculatePrice } from 'src/helpers/Prices/calculatePrice';
import { calculateRecommendedPrice } from 'src/helpers/Prices/calculateRecommendedPrice';
import { AvailabilitySelect } from 'src/scenes/Availabilities';
import getProductPurchasePrice from 'helpers/src/prices/getProductPurchasePrice';  
import { SHARED_STOCK_CURRENCIES, STOCK_SOURCE_CURRENCY } from 'data-layer/src/helpers/products/sharedStock';

interface IPricesRowProps {
  sku: string | undefined;
  name: string;
  currency: GQL.ICurrency;
  defaultCurrency?: GQL.ICurrency;
  prices: GQL.IPrice[];
  priceObject: GQL.IPrice;
  disabled?: boolean;
  availabilityMode?: boolean;
  stockMode?: boolean;
  showPurchasePrice: boolean;
  onChange: (e: any) => void;
}
class PricesRow extends React.Component<IPricesRowProps> {

  public constructor(props: IPricesRowProps) {
    super(props);
  }

  public render() {
    const { defaultCurrency, currency, prices, priceObject, disabled, availabilityMode, stockMode, showPurchasePrice, sku } = this.props;
    // USD and CZK share the stock of the EUR record, so they only show its values
    const mirrorsStock = currency.value !== STOCK_SOURCE_CURRENCY && SHARED_STOCK_CURRENCIES.indexOf(currency.value) >= 0
      && !!defaultCurrency && defaultCurrency.value === STOCK_SOURCE_CURRENCY;
    const stockObject: Partial<GQL.IPrice> = mirrorsStock
      ? (prices.find((p: GQL.IPrice) => p.currencyId === (defaultCurrency as GQL.ICurrency).id) || {})
      : priceObject;
    const mirrorLabel = mirrorsStock ? ` (= ${STOCK_SOURCE_CURRENCY})` : '';

    return (
      <>
        <Row gutter={15} style={{ padding: '0 10px' }}>
          <Col span={4}>
            <FormItem label={'Recommended price'}>
              <Input
                key={currency.value}
                name={'recommendedPriceWithout'}
                type={'number'}
                value={`${priceObject.recommendedPriceWithout !== null && priceObject.recommendedPriceWithout !== undefined
                  ? priceObject.recommendedPriceWithout
                  : ''}`}
                step="0.01"
                onChange={this.onChange}
                addonAfter={currency.value}
                disabled={disabled === true}
              />
            </FormItem>
          </Col>

        <Col span={3}>
          <FormItem label={'Discount'}>
            <DiscountInput
              name={'discount'}
              prices={prices}
              currency={currency}
              onChange={this.onChangeDiscount}
              disabled={disabled === true}
            />
          </FormItem>
        </Col>

        <Col span={3}>
          <FormItem label={'Minimal price (after discount)'}>
            <Input
              key={currency.value}
              name={'minimalPrice'}
              type={'number'}
              value={`${priceObject.minimalPrice !== null && priceObject.minimalPrice !== undefined
                ? priceObject.minimalPrice
                : ''}`}
              onChange={this.onChange}
              addonAfter={currency.value}
              disabled={disabled === true}
            />
          </FormItem>
        </Col>

          <Col span={3}>
            <FormItem label={'Price'}>
              <Input
                key={currency.value}
                name={'priceWithout'}
                type={'number'}
                value={`${priceObject.priceWithout !== null && priceObject.priceWithout !== undefined
                  ? priceObject.priceWithout
                  : ''}`}
                step="0.01"
                onChange={this.onChange}
                addonAfter={currency.value}
                disabled={disabled === true}
              />
            </FormItem>
          </Col>
        {availabilityMode && <Col span={3}>
            <AvailabilitySelect
              key={`availabilityId-${mirrorsStock ? stockObject.availabilityId : ''}`}
              name="availabilityId"
              label={`Availability${mirrorLabel}`}
              value={stockObject.availabilityId || undefined}
              placeholder="Availability"
              disabled={mirrorsStock}
              onChange={this.onChangeAvailabilty('availabilityId')}
            />
          </Col>}
          {stockMode && <>
          <Col span={2}>
            <FormItem label={`Stock amount${mirrorLabel}`}>
              <Input
                name={'stockAmount'}
                type={'number'}
                value={Number.isNaN(Number(stockObject.stockAmount)) ? undefined : stockObject.stockAmount}
                onChange={this.onChange}
                disabled={disabled === true || mirrorsStock}
              />
            </FormItem>
          </Col>
          <Col span={2}>
          <AvailabilitySelect
              key={`outOfStockTransitionStatusId-${mirrorsStock ? stockObject.outOfStockTransitionStatusId : ''}`}
              name="outOfStockTransitionStatusId"
              label={`Out of stock transition${mirrorLabel}`}
              value={stockObject.outOfStockTransitionStatusId || undefined}
              placeholder="Out of stock transition"
              disabled={mirrorsStock}
              onChange={this.onChangeAvailabilty('outOfStockTransitionStatusId')}
            />  
          </Col>
          </>}
        </Row>
        {showPurchasePrice && currency.hasPurchasePrice && <Row>
            <Col span={24} style={{ fontStyle: 'italic', fontSize: '12px', color: 'rgb(255, 77, 79)', paddingBottom: '10px', paddingLeft: '10px' }}>
            {`Purchase price calculated as 78% of EUR price or minimal price converted with exchange rate ${currency.exchangeRate} is ${getProductPurchasePrice(defaultCurrency, prices, currency, sku) || '-' } ${currency.value}` }
          </Col>
        </Row>}
      </>
    );
  }

  onChange = (e: any) => {
    const { prices, currency: { id: currencyId } } = this.props;
    const { name, value } = e.target;
    const priceIndex = this.props.prices.findIndex((p: GQL.IPrice) => p.currencyId === currencyId);

    // set new price
    const price = (priceIndex > -1)
      ? prices[priceIndex]
      : { ...prices[0], currencyId }

    if (name === 'recommendedPriceWithout') {
      price.recommendedPriceWithout = parseFloat(value) >= 0 ? parseFloat(value) : null;
      price.priceWithout = calculatePrice(price);
    }
    // konečná cena
    if (name === 'priceWithout') {
      price.priceWithout = parseFloat(value) >= 0 ? parseFloat(value) : null;
      price.recommendedPriceWithout = calculateRecommendedPrice(price);
    }

    if (name === 'minimalPrice') {
      price.minimalPrice = value;
    }

    if(name === 'stockAmount') {
      price.stockAmount = parseInt(value);
    }

    if(name === 'purchasePrice') {
      price.purchasePrice = parseFloat(value) >= 0 ? parseFloat(value) : null
    }

    if (priceIndex > -1) {
      prices[priceIndex] = price;
    } else {
      prices.push(price);
    }

    this.props.onChange({
      target: {
        name: this.props.name,
        value: [...prices],
      }
    });
  }


  onChangeAvailabilty = (key: string) => (e: any) => {
    const { prices, currency: { id: currencyId } } = this.props;
    const priceIndex = this.props.prices.findIndex((p: GQL.IPrice) => p.currencyId === currencyId);

    // set new price
    const price = (priceIndex > -1)
      ? prices[priceIndex]
      : { currencyId: currencyId } as GQL.IPrice;

    price[key] = e.target.value;

    if (priceIndex > -1) {
      prices[priceIndex] = price;
    } else {
      prices.push(price);
    }

    this.props.onChange({
      target: {
        name: this.props.name,
        value: [...prices],
      }
    });
  }

  onChangeDiscount = (e: any) => {
    this.props.onChange({
      target: {
        name: this.props.name,
        value: e.target.value,
      }
    });
  }
}

export default PricesRow;


// WEBPACK FOOTER //
// ./src/components/Others/PricesWithDiscountInput/components/PricesRow/PricesRow.tsx